import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 11,
  steps: [
    addColumns({
      table: 'messages',
      columns: [{ name: 'reply_message', type: 'string', isOptional: true }]
    })
  ]
}
